import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import BlogNav from '@/pages/blog/components/BlogNav';
import StickyCtaBar from '@/pages/blog/components/StickyCtaBar';

interface Post {
  slug: string;
  title: string;
  category: string;
  date: string;
}

const allPosts: Post[] = [
  // Strength Training
  { slug: 'strength-training-for-men-over-60-beginners-guide', title: "The Complete Beginner's Guide to Strength Training for Men Over 60", category: 'Strength Training', date: 'March 15, 2025' },
  { slug: 'best-exercises-for-men-over-60', title: '15 Best Exercises for Men Over 60 (Joint-Safe & Effective)', category: 'Strength Training', date: 'March 18, 2025' },
  { slug: 'how-to-build-muscle-after-60', title: 'How to Build Muscle After 60: The Science-Backed Approach', category: 'Strength Training', date: 'March 20, 2025' },
  { slug: 'weight-training-over-60-safety-tips', title: 'Weight Training Over 60: 10 Safety Tips Every Man Needs to Know', category: 'Strength Training', date: 'March 22, 2025' },
  { slug: 'resistance-training-for-seniors', title: 'Why Resistance Training is the #1 Priority for Men Over 60', category: 'Strength Training', date: 'March 25, 2025' },
  { slug: 'bodyweight-exercises-for-men-over-60', title: '12 Bodyweight Exercises for Men Over 60 (No Equipment Needed)', category: 'Strength Training', date: 'March 28, 2025' },
  { slug: 'dumbbell-workout-for-men-over-60', title: 'The Perfect Dumbbell Workout for Men Over 60', category: 'Strength Training', date: 'April 1, 2025' },
  { slug: 'home-workout-plan-for-men-over-60', title: 'Home Workout Plan for Men Over 60: No Gym Required', category: 'Strength Training', date: 'April 3, 2025' },
  // Weight Loss
  { slug: 'how-to-lose-belly-fat-after-60-male', title: 'How to Lose Belly Fat After 60 (Male): What Actually Works', category: 'Weight Loss', date: 'April 5, 2025' },
  { slug: 'weight-loss-for-men-over-60', title: 'Weight Loss for Men Over 60: The No-Diet Approach', category: 'Weight Loss', date: 'April 7, 2025' },
  { slug: 'losing-weight-at-60-years-old-male', title: "Losing Weight at 60 Years Old: A Man's Realistic Guide", category: 'Weight Loss', date: 'April 9, 2025' },
  { slug: 'metabolism-after-60-how-to-speed-it-up', title: 'Metabolism After 60: How to Rev It Back Up', category: 'Weight Loss', date: 'April 11, 2025' },
  { slug: 'best-diet-for-men-over-60-to-lose-weight', title: 'Best Diet for Men Over 60 to Lose Weight (Without Starving)', category: 'Weight Loss', date: 'April 13, 2025' },
  { slug: 'intermittent-fasting-for-men-over-60', title: 'Intermittent Fasting for Men Over 60: Safe or Not?', category: 'Weight Loss', date: 'April 15, 2025' },
  // Motivation
  { slug: 'fitness-after-60-where-to-start', title: 'Fitness After 60: Where the Hell Do You Even Start?', category: 'Motivation', date: 'April 17, 2025' },
  { slug: 'too-old-to-get-in-shape', title: 'Am I Too Old to Get in Shape? (The Answer Will Surprise You)', category: 'Motivation', date: 'May 1, 2025' },
  { slug: 'fitness-transformation-over-60', title: 'Fitness Transformations Over 60: Real Men, Real Results', category: 'Motivation', date: 'May 5, 2025' },
  { slug: 'workout-motivation-for-older-men', title: 'Workout Motivation for Older Men: How to Stay Consistent', category: 'Motivation', date: 'May 8, 2025' },
  { slug: 'getting-back-in-shape-at-60', title: 'Getting Back in Shape at 60: Your Week-by-Week Plan', category: 'Motivation', date: 'May 12, 2025' },
  // Health Conditions
  { slug: 'exercise-after-heart-attack-over-60', title: 'Exercise After a Heart Attack: A Safe Guide for Men Over 60', category: 'Health Conditions', date: 'May 15, 2025' },
  { slug: 'exercise-with-high-blood-pressure-over-60', title: "Exercising with High Blood Pressure Over 60: Do's and Don'ts", category: 'Health Conditions', date: 'May 18, 2025' },
  { slug: 'exercise-for-diabetic-men-over-60', title: 'Exercise for Diabetic Men Over 60: Lower Blood Sugar Naturally', category: 'Health Conditions', date: 'May 22, 2025' },
  { slug: 'exercise-with-arthritis-over-60', title: 'Working Out with Arthritis Over 60: What You Can Still Do', category: 'Health Conditions', date: 'May 25, 2025' },
  { slug: 'exercises-after-knee-replacement-over-60', title: 'Exercises After Knee Replacement: Getting Strong Again Over 60', category: 'Health Conditions', date: 'May 28, 2025' },
  { slug: 'exercise-for-prostate-health-over-60', title: 'Exercise and Prostate Health: What Men Over 60 Should Know', category: 'Health Conditions', date: 'June 1, 2025' },
  // Health & Recovery
  { slug: 'joint-pain-exercises-for-seniors', title: 'Exercise WITH Joint Pain: Safe Movements for Men Over 60', category: 'Health & Recovery', date: 'June 5, 2025' },
  { slug: 'knee-friendly-exercises-for-seniors', title: '10 Knee-Friendly Exercises for Men Over 60', category: 'Health & Recovery', date: 'June 8, 2025' },
  { slug: 'shoulder-exercises-for-men-over-60', title: 'Shoulder Exercises for Men Over 60 (Rotator Cuff Safe)', category: 'Health & Recovery', date: 'June 12, 2025' },
  { slug: 'back-exercises-for-men-over-60', title: 'Back Strengthening Exercises for Men Over 60', category: 'Health & Recovery', date: 'June 15, 2025' },
  { slug: 'balance-exercises-for-men-over-60', title: 'Balance Exercises for Men Over 60: Prevent Falls, Build Stability', category: 'Health & Recovery', date: 'June 18, 2025' },
  { slug: 'stretching-routine-for-men-over-60', title: 'The Daily Stretching Routine Every Man Over 60 Needs', category: 'Health & Recovery', date: 'January 5, 2026' },
  { slug: 'recovery-tips-for-older-athletes', title: 'Recovery After Workouts: Why Men Over 60 Need More Rest', category: 'Health & Recovery', date: 'January 8, 2026' },
  // Nutrition
  { slug: 'protein-intake-for-men-over-60', title: 'How Much Protein Do Men Over 60 Actually Need?', category: 'Nutrition', date: 'January 12, 2026' },
  { slug: 'best-protein-powder-for-men-over-60', title: 'Best Protein Powder for Men Over 60 (2026 Guide)', category: 'Nutrition', date: 'January 15, 2026' },
  { slug: 'supplements-for-men-over-60', title: "Supplements for Men Over 60: What Works and What's a Waste", category: 'Nutrition', date: 'January 18, 2026' },
  { slug: 'meal-plan-for-men-over-60', title: 'Simple Meal Plan for Men Over 60 (Build Muscle, Lose Fat)', category: 'Nutrition', date: 'January 22, 2026' },
  { slug: 'creatine-for-men-over-60', title: 'Creatine for Men Over 60: Is It Safe? (What the Science Says)', category: 'Nutrition', date: 'January 25, 2026' },
  // Comparisons
  { slug: 'best-workout-program-for-men-over-60', title: 'Best Workout Program for Men Over 60 in 2026 (Honest Review)', category: 'Comparisons', date: 'February 1, 2026' },
  { slug: 'personal-trainer-vs-online-program-over-60', title: 'Personal Trainer vs Online Program for Men Over 60', category: 'Comparisons', date: 'February 5, 2026' },
  { slug: 'gym-vs-home-workout-for-men-over-60', title: 'Gym vs Home Workouts for Men Over 60: Which Is Better?', category: 'Comparisons', date: 'February 8, 2026' },
  { slug: 'crossfit-over-60', title: 'CrossFit Over 60: Is It Safe? (Better Alternatives)', category: 'Comparisons', date: 'February 12, 2026' },
  { slug: 'yoga-vs-strength-training-over-60', title: 'Yoga vs Strength Training for Men Over 60: Which Builds More Muscle?', category: 'Comparisons', date: 'February 15, 2026' },
];

const categories = ['All', 'Strength Training', 'Weight Loss', 'Motivation', 'Health Conditions', 'Health & Recovery', 'Nutrition', 'Comparisons'];

const categoryColors: Record<string, string> = {
  'Strength Training': 'text-[#c8a96e]',
  'Weight Loss': 'text-orange-400',
  'Motivation': 'text-yellow-400',
  'Health Conditions': 'text-red-400',
  'Health & Recovery': 'text-green-400',
  'Nutrition': 'text-blue-400',
  'Comparisons': 'text-purple-400',
};

export default function BlogIndexPage() {
  const [activeCategory, setActiveCategory] = useState('All');

  useEffect(() => {
    document.title = 'Fitness Blog for Men Over 60 | Mason Hale Fitness';
    const setMeta = (name: string, content: string) => {
      let el = document.querySelector(`meta[name="${name}"]`) as HTMLMetaElement | null;
      if (!el) { el = document.createElement('meta'); el.setAttribute('name', name); document.head.appendChild(el); }
      el.setAttribute('content', content);
    };
    setMeta('description', 'Practical, no-BS fitness and weight loss advice for men over 60. Strength training, fat loss, nutrition, and motivation from Mason Hale — 42 free articles.');
    setMeta('keywords', 'fitness for men over 60, strength training over 60, weight loss over 60');
  }, []);

  const filtered = activeCategory === 'All' ? allPosts : allPosts.filter(p => p.category === activeCategory);

  const grouped = categories.slice(1).reduce<Record<string, Post[]>>((acc, cat) => {
    const posts = allPosts.filter(p => p.category === cat);
    if (posts.length) acc[cat] = posts;
    return acc;
  }, {});

  return (
    <div className="min-h-screen bg-[#0a0a0a]">
      <BlogNav />
      <main className="pt-20 pb-24">
        <div className="max-w-5xl mx-auto px-5 sm:px-8 py-10 sm:py-14">

          {/* Header */}
          <div className="mb-10">
            <p className="text-[#c8a96e] text-xs font-bold tracking-[0.25em] uppercase mb-3">Mason Hale Fitness</p>
            <h1 className="text-white text-3xl sm:text-4xl font-black leading-tight mb-4">
              Fitness Advice for Men Over 60
            </h1>
            <p className="text-gray-400 text-base leading-relaxed max-w-2xl">
              No fluff. No gimmicks. 42 articles covering strength training, weight loss, nutrition, and health — all written for men over 60 by someone who's done it himself.
            </p>
            <div className="flex items-center gap-4 mt-4">
              <span className="text-gray-600 text-sm">{allPosts.length} articles</span>
              <span className="text-gray-700">·</span>
              <span className="text-gray-600 text-sm">{categories.length - 1} categories</span>
            </div>
          </div>

          {/* Category Filter */}
          <div className="flex flex-wrap gap-2 mb-10">
            {categories.map((cat) => (
              <button
                key={cat}
                onClick={() => setActiveCategory(cat)}
                className={`px-4 py-1.5 border text-xs font-semibold tracking-wide rounded-full cursor-pointer transition-all whitespace-nowrap ${
                  activeCategory === cat
                    ? 'bg-[#c8a96e] border-[#c8a96e] text-black'
                    : 'bg-[#111111] border-white/10 text-gray-400 hover:border-[#c8a96e]/40 hover:text-[#c8a96e]'
                }`}
              >
                {cat}
                {cat !== 'All' && (
                  <span className="ml-1.5 opacity-60">
                    ({allPosts.filter(p => p.category === cat).length})
                  </span>
                )}
              </button>
            ))}
          </div>

          {/* Filtered Grid */}
          {activeCategory !== 'All' ? (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 mb-16">
              {filtered.map((post) => (
                <Link
                  key={post.slug}
                  to={`/blog/${post.slug}`}
                  className="block bg-[#111111] border border-white/8 rounded-lg p-6 hover:border-[#c8a96e]/40 transition-all group"
                >
                  <span className={`text-xs font-bold tracking-[0.15em] uppercase block mb-2 ${categoryColors[post.category] || 'text-[#c8a96e]'}`}>
                    {post.category}
                  </span>
                  <h2 className="text-white text-sm font-bold leading-snug mb-3 group-hover:text-[#c8a96e] transition-colors">
                    {post.title}
                  </h2>
                  <p className="text-gray-600 text-xs">{post.date}</p>
                </Link>
              ))}
            </div>
          ) : (
            /* Grouped by Category */
            <div className="space-y-14 mb-16">
              {Object.entries(grouped).map(([cat, posts]) => (
                <div key={cat}>
                  <div className="flex items-center gap-3 mb-5">
                    <h2 className={`text-lg font-black uppercase tracking-wide ${categoryColors[cat] || 'text-[#c8a96e]'}`}>
                      {cat}
                    </h2>
                    <span className="text-gray-700 text-sm">({posts.length} articles)</span>
                    <div className="flex-1 h-px bg-white/5" />
                  </div>
                  <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                    {posts.map((post) => (
                      <Link
                        key={post.slug}
                        to={`/blog/${post.slug}`}
                        className="block bg-[#111111] border border-white/8 rounded-lg p-5 hover:border-[#c8a96e]/40 transition-all group"
                      >
                        <h3 className="text-white text-sm font-bold leading-snug mb-2 group-hover:text-[#c8a96e] transition-colors">
                          {post.title}
                        </h3>
                        <p className="text-gray-600 text-xs">{post.date}</p>
                      </Link>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          )}

          {/* CTA Block */}
          <div className="bg-[#111111] border border-[#c8a96e]/20 rounded-lg p-8 text-center">
            <p className="text-[#c8a96e] text-xs font-bold tracking-[0.2em] uppercase mb-3">Ready to Start?</p>
            <h2 className="text-white text-2xl font-black mb-4">Get The Over-60 Strength Blueprint</h2>
            <p className="text-gray-400 text-sm mb-6 max-w-lg mx-auto">
              The complete joint-safe strength training system for men over 60. The same system Mason used to lose 55 lbs and get off 3 medications. One-time purchase, no subscriptions.
            </p>
            <a
              href="https://masonhalefit.com"
              className="inline-flex items-center gap-2 px-8 py-3 bg-[#c8a96e] text-black text-sm font-black tracking-[0.15em] uppercase rounded-sm hover:bg-[#d9bc82] transition-all cursor-pointer whitespace-nowrap"
            >
              Get The Program — $19.99
            </a>
          </div>
        </div>
      </main>
      <StickyCtaBar />
    </div>
  );
}
